export const GET_BRANDS_RECEIPT_CUSTOMIZATION =
  'providers/settings/ReceiptCustomization/GET_BRANDS_RECEIPT_CUSTOMIZATION';

export const GET_BRAND_RECEIPT_CUSTOMIZATION =
  'providers/settings/ReceiptCustomization/GET_BRAND_RECEIPT_CUSTOMIZATION';

export const UPDATE_BRAND_RECEIPT_CUSTOMIZATION =
  'providers/settings/ReceiptCustomization/UPDATE_BRAND_RECEIPT_CUSTOMIZATION';
